import React from 'react'
import { sportableColors } from '../../../const'
import {
  Sport,
  SportTypeValues
} from '../../../metrics_server/sports/data_types'
import { getSport } from '../../../metrics_server/sports/functions'

export interface PitchProps {
  color?: string
  scale: number
  active?: boolean
  sport?: Sport
  sportType?: SportTypeValues
}

const SoccerPitchSvg = ({ color, scale, active }: any) => (
  <svg
    width={`${33 * scale}`}
    height={`${43 * scale}`}
    viewBox='0 0 33 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M30.1499 0C29.6479 0 2.2957 0 1.89211 0C0.848814 0 0 0.900138 0 2.00648V41.3935C0 42.4999 0.848814 43.4 1.89211 43.4C2.26254 43.4 29.7455 43.4 30.1499 43.4C31.1932 43.4 32.042 42.4999 32.042 41.3935V2.00648C32.042 0.900138 31.1932 0 30.1499 0ZM20.3872 35.5944H19.1046C18.4517 32.027 13.5939 32.0073 12.9374 35.5944H11.6548C10.6749 35.5944 9.87759 36.4399 9.87759 37.4792V42.1285H5.01383C4.74648 40.0309 3.17705 38.3665 1.19899 38.083V22.3357H10.8323C11.1307 25.0921 13.3432 27.2401 16.021 27.2401C18.6988 27.2401 20.9113 25.0921 21.2097 22.3357H30.843V38.083C28.8649 38.3665 27.2955 40.0309 27.0282 42.1285H22.1644V37.4792C22.1644 36.4399 21.3671 35.5944 20.3872 35.5944ZM17.8686 35.5944H14.1734C14.7539 33.7024 17.2873 33.6996 17.8686 35.5944ZM11.6548 7.80556H12.9374C13.5903 11.373 18.4481 11.3927 19.1046 7.80556H20.3872C21.3671 7.80556 22.1644 6.96005 22.1644 5.92085V1.27148H27.0282C27.2955 3.36912 28.8649 5.03345 30.843 5.31695V21.0643H21.2097C20.9113 18.3079 18.6988 16.1599 16.021 16.1599C13.3432 16.1599 11.1307 18.3079 10.8323 21.0643H1.19899V5.34452C3.29074 5.16834 4.97945 3.45463 5.25768 1.27148H9.87759V5.92085C9.87759 6.96005 10.6749 7.80556 11.6548 7.80556ZM14.1734 7.80556H17.8686C17.2881 9.69756 14.7547 9.70037 14.1734 7.80556ZM12.0407 21.0643C12.331 19.011 14.0052 17.4314 16.021 17.4314C18.0368 17.4314 19.711 19.011 20.0013 21.0643H12.0407ZM20.0013 22.3357C19.711 24.389 18.0368 25.9686 16.021 25.9686C14.0052 25.9686 12.331 24.389 12.0407 22.3357H20.0013ZM30.843 2.00648V4.0298C29.5272 3.76897 28.4879 2.66691 28.2419 1.27148H30.1499C30.5321 1.27148 30.843 1.60119 30.843 2.00648ZM20.9654 1.27148V5.92085C20.9654 6.259 20.706 6.53407 20.3872 6.53407H11.6548C11.336 6.53407 11.0766 6.259 11.0766 5.92085V1.27148H20.9654ZM1.89211 1.27148H4.04392C3.78294 2.75211 2.62892 3.90296 1.19899 4.06846V2.00648C1.19899 1.60119 1.50994 1.27148 1.89211 1.27148ZM1.19899 41.3935V39.3702C2.51484 39.631 3.5541 40.7331 3.80006 42.1285H1.89211C1.50994 42.1285 1.19899 41.7988 1.19899 41.3935ZM11.0766 42.1285V37.4792C11.0766 37.141 11.336 36.8659 11.6548 36.8659H20.3872C20.706 36.8659 20.9654 37.141 20.9654 37.4792V42.1285H11.0766ZM30.1499 42.1285H28.2419C28.4879 40.7331 29.5272 39.631 30.843 39.3702V41.3935C30.843 41.7988 30.5321 42.1285 30.1499 42.1285Z'
      fill={color}
    />
  </svg>
)

const AmericanOrCanadianFootballPitchSvg = ({ color, scale, active }: any) => (
  <svg
    width={`${31 * scale}`}
    height={`${45 * scale}`}
    viewBox='0 0 31 45'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 0.637452L0 43.5205C0 43.8682 0.2318 44.1 0.5795 44.1H30.192C30.5397 44.1 30.7715 43.8682 30.7715 43.5205L30.7715 0.579498C30.7715 0.231798 30.5397 -2.1184e-06 30.192 -2.1184e-06H0.5795C0.2318 0.0579479 0 0.289752 0 0.637452ZM28.4535 7.59146C28.4535 7.93916 28.6853 8.17096 29.033 8.17096H29.6125V8.80841H1.159V8.17096H1.68055C2.02825 8.17096 2.26005 7.93916 2.26005 7.59146C2.26005 7.24376 2.02825 7.01196 1.68055 7.01196H1.159V6.31655H29.6125V7.01196H29.033C28.7432 7.01196 28.4535 7.30171 28.4535 7.59146ZM28.4535 11.2423C28.4535 11.59 28.6853 11.8218 29.033 11.8218H29.6125V12.4593L1.159 12.4593V11.8218H1.68055C2.02825 11.8218 2.26005 11.59 2.26005 11.2423C2.26005 10.8946 2.02825 10.6628 1.68055 10.6628H1.159V9.96741H29.6125V10.6628H29.033C28.7432 10.6628 28.4535 10.8946 28.4535 11.2423ZM28.4535 14.8352C28.4535 15.1829 28.6853 15.4147 29.033 15.4147H29.6125V16.0522L1.159 16.0522V15.4147H1.68055C2.02825 15.4147 2.26005 15.1829 2.26005 14.8352C2.26005 14.4875 2.02825 14.2557 1.68055 14.2557H1.159V13.5603L29.6125 13.5603V14.2557H29.033C28.7432 14.2557 28.4535 14.5455 28.4535 14.8352ZM28.4535 18.4861C28.4535 18.8338 28.6853 19.0656 29.033 19.0656H29.6125V19.703L1.159 19.703V19.0656H1.68055C2.02825 19.0656 2.26005 18.8338 2.26005 18.4861C2.26005 18.1384 2.02825 17.9066 1.68055 17.9066H1.159V17.2112L29.6125 17.2112V17.9066H29.033C28.7432 17.9066 28.4535 18.1384 28.4535 18.4861ZM28.4535 22.079C28.4535 22.4267 28.6853 22.6585 29.033 22.6585H29.6125V23.2959L1.159 23.2959V22.6585H1.68055C2.02825 22.6585 2.26005 22.4267 2.26005 22.079C2.26005 21.7313 2.02825 21.4995 1.68055 21.4995H1.159V20.8041L29.6125 20.8041V21.4995H29.033C28.7432 21.4995 28.4535 21.7892 28.4535 22.079ZM28.4535 25.7298C28.4535 26.0775 28.6853 26.3093 29.033 26.3093H29.6125V26.9468L1.159 26.9468V26.3093H1.68055C2.02825 26.3093 2.26005 26.0775 2.26005 25.7298C2.26005 25.3821 2.02825 25.1503 1.68055 25.1503H1.159V24.4549L29.6125 24.4549V25.1503H29.033C28.7432 25.1503 28.4535 25.3821 28.4535 25.7298ZM28.4535 29.3227C28.4535 29.6704 28.6853 29.9022 29.033 29.9022H29.6125V30.5397H1.159V29.9022H1.68055C2.02825 29.9022 2.26005 29.6704 2.26005 29.3227C2.26005 28.975 2.02825 28.7432 1.68055 28.7432H1.159V28.0478L29.6125 28.0478V28.7432H29.033C28.7432 28.7432 28.4535 29.033 28.4535 29.3227ZM28.4535 32.9736C28.4535 33.3213 28.6853 33.5531 29.033 33.5531H29.6125V34.1905H1.159V33.5531H1.68055C2.02825 33.5531 2.26005 33.3213 2.26005 32.9736C2.26005 32.6259 2.02825 32.3941 1.68055 32.3941H1.159V31.6987H29.6125V32.3941H29.033C28.7432 32.3941 28.4535 32.6259 28.4535 32.9736ZM28.4535 36.5665C28.4535 36.9142 28.6853 37.146 29.033 37.146H29.6125V37.7834H1.159V37.146H1.68055C2.02825 37.146 2.26005 36.9142 2.26005 36.5665C2.26005 36.2188 2.02825 35.987 1.68055 35.987H1.159V35.2916H29.6125V35.987H29.033C28.7432 35.987 28.4535 36.2767 28.4535 36.5665ZM1.159 42.941L1.159 38.9424H29.6125V42.941H1.159ZM29.6125 1.21695V5.2155H1.159L1.159 1.21695H29.6125Z'
      fill={color}
    />
    <path
      d='M7.93906 36.5665C7.93906 36.2188 7.70726 35.987 7.35956 35.987H6.78006C6.43236 35.987 6.20056 36.2188 6.20056 36.5665C6.20056 36.9142 6.43236 37.146 6.78006 37.146H7.35956C7.70726 37.146 7.93906 36.9142 7.93906 36.5665Z'
      fill={color}
    />
    <path
      d='M7.93906 32.9735C7.93906 32.6258 7.70726 32.394 7.35956 32.394H6.78006C6.43236 32.394 6.20056 32.6258 6.20056 32.9735C6.20056 33.3212 6.43236 33.553 6.78006 33.553H7.35956C7.70726 33.553 7.93906 33.2633 7.93906 32.9735Z'
      fill={color}
    />
    <path
      d='M7.93906 29.3227C7.93906 28.975 7.70726 28.7432 7.35956 28.7432H6.78006C6.43236 28.7432 6.20056 28.975 6.20056 29.3227C6.20056 29.6704 6.43236 29.9022 6.78006 29.9022H7.35956C7.70726 29.9022 7.93906 29.6704 7.93906 29.3227Z'
      fill={color}
    />
    <path
      d='M7.93906 25.7298C7.93906 25.3821 7.70726 25.1503 7.35956 25.1503H6.78006C6.43236 25.1503 6.20056 25.3821 6.20056 25.7298C6.20056 26.0775 6.43236 26.3093 6.78006 26.3093H7.35956C7.70726 26.3093 7.93906 26.0195 7.93906 25.7298Z'
      fill={color}
    />
    <path
      d='M7.93906 22.0789C7.93906 21.7312 7.70726 21.4994 7.35956 21.4994H6.78006C6.43236 21.4994 6.20056 21.7312 6.20056 22.0789C6.20056 22.4266 6.43236 22.6584 6.78006 22.6584H7.35956C7.70726 22.6584 7.93906 22.4266 7.93906 22.0789Z'
      fill={color}
    />
    <path
      d='M7.93906 18.4861C7.93906 18.1384 7.70726 17.9066 7.35956 17.9066H6.78006C6.43236 17.9066 6.20056 18.1384 6.20056 18.4861C6.20056 18.8338 6.43236 19.0656 6.78006 19.0656H7.35956C7.70726 19.0656 7.93906 18.7758 7.93906 18.4861Z'
      fill={color}
    />
    <path
      d='M7.93906 14.8352C7.93906 14.4875 7.70726 14.2557 7.35956 14.2557H6.78006C6.43236 14.2557 6.20056 14.4875 6.20056 14.8352C6.20056 15.1829 6.43236 15.4147 6.78006 15.4147H7.35956C7.70726 15.4147 7.93906 15.1829 7.93906 14.8352Z'
      fill={color}
    />
    <path
      d='M7.93906 11.2423C7.93906 10.8946 7.70726 10.6628 7.35956 10.6628H6.78006C6.43236 10.6628 6.20056 10.8946 6.20056 11.2423C6.20056 11.59 6.43236 11.8218 6.78006 11.8218H7.35956C7.70726 11.8218 7.93906 11.532 7.93906 11.2423Z'
      fill={color}
    />
    <path
      d='M7.93906 7.59146C7.93906 7.24376 7.70726 7.01196 7.35956 7.01196H6.78006C6.43236 7.01196 6.20056 7.24376 6.20056 7.59146C6.20056 7.93916 6.43236 8.17096 6.78006 8.17096H7.35956C7.70726 8.17096 7.93906 7.93916 7.93906 7.59146Z'
      fill={color}
    />
    <path
      d='M13.5 7C13.8 7 14 6.6 14 6V5C14 4.4 13.8 4 13.5 4C13.2 4 13 4.4 13 5V6C13 6.6 13.2 7 13.5 7Z'
      fill={color}
    />
    <path
      d='M13.5 45C13.8 45 14 44.6 14 44V43C14 42.4 13.8 42 13.5 42C13.2 42 13 42.4 13 43V44C13 44.6 13.2 45 13.5 45Z'
      fill={color}
    />
    <path
      d='M16.5 45C16.8 45 17 44.6 17 44V43C17 42.4 16.8 42 16.5 42C16.2 42 16 42.4 16 43V44C16 44.6 16.2 45 16.5 45Z'
      fill={color}
    />
    <path
      d='M16.5 7C16.8 7 17 6.6 17 6V5C17 4.4 16.8 4 16.5 4C16.2 4 16 4.4 16 5V6C16 6.6 16.2 7 16.5 7Z'
      fill={color}
    />
    <path
      d='M22.7163 35.987C22.3686 35.987 22.1368 36.2188 22.1368 36.5665C22.1368 36.9142 22.3686 37.146 22.7163 37.146H23.2958C23.6435 37.146 23.8753 36.9142 23.8753 36.5665C23.8753 36.2188 23.6435 35.987 23.2958 35.987H22.7163Z'
      fill={color}
    />
    <path
      d='M22.7163 32.394C22.3686 32.394 22.1368 32.6258 22.1368 32.9735C22.1368 33.3212 22.3686 33.553 22.7163 33.553H23.2958C23.6435 33.553 23.8753 33.3212 23.8753 32.9735C23.8753 32.6258 23.6435 32.394 23.2958 32.394H22.7163Z'
      fill={color}
    />
    <path
      d='M22.7163 28.7432C22.3686 28.7432 22.1368 28.975 22.1368 29.3227C22.1368 29.6704 22.3686 29.9022 22.7163 29.9022H23.2958C23.6435 29.9022 23.8753 29.6704 23.8753 29.3227C23.8753 28.975 23.6435 28.7432 23.2958 28.7432H22.7163Z'
      fill={color}
    />
    <path
      d='M22.7163 25.1503C22.3686 25.1503 22.1368 25.3821 22.1368 25.7298C22.1368 26.0775 22.3686 26.3093 22.7163 26.3093H23.2958C23.6435 26.3093 23.8753 26.0775 23.8753 25.7298C23.8753 25.3821 23.6435 25.1503 23.2958 25.1503H22.7163Z'
      fill={color}
    />
    <path
      d='M22.7163 21.4994C22.3686 21.4994 22.1368 21.7312 22.1368 22.0789C22.1368 22.4266 22.3686 22.6584 22.7163 22.6584H23.2958C23.6435 22.6584 23.8753 22.4266 23.8753 22.0789C23.8753 21.7312 23.6435 21.4994 23.2958 21.4994H22.7163Z'
      fill={color}
    />
    <path
      d='M22.7163 17.9066C22.3686 17.9066 22.1368 18.1384 22.1368 18.4861C22.1368 18.8338 22.3686 19.0656 22.7163 19.0656H23.2958C23.6435 19.0656 23.8753 18.8338 23.8753 18.4861C23.8753 18.1384 23.6435 17.9066 23.2958 17.9066H22.7163Z'
      fill={color}
    />
    <path
      d='M22.7163 14.2557C22.3686 14.2557 22.1368 14.4875 22.1368 14.8352C22.1368 15.1829 22.3686 15.4147 22.7163 15.4147H23.2958C23.6435 15.4147 23.8753 15.1829 23.8753 14.8352C23.8753 14.4875 23.6435 14.2557 23.2958 14.2557H22.7163Z'
      fill={color}
    />
    <path
      d='M22.7163 10.6628C22.3686 10.6628 22.1368 10.8946 22.1368 11.2423C22.1368 11.59 22.3686 11.8218 22.7163 11.8218H23.2958C23.6435 11.8218 23.8753 11.59 23.8753 11.2423C23.8753 10.8946 23.6435 10.6628 23.2958 10.6628H22.7163Z'
      fill={color}
    />
    <path
      d='M22.7163 7.01196C22.3686 7.01196 22.1368 7.24376 22.1368 7.59146C22.1368 7.93916 22.3686 8.17096 22.7163 8.17096H23.2958C23.6435 8.17096 23.8753 7.93916 23.8753 7.59146C23.8753 7.24376 23.6435 7.01196 23.2958 7.01196H22.7163Z'
      fill={color}
    />
  </svg>
)

const AFLPitchSvg = ({ color, scale, active }: any) => (
  <svg
    width={`${40 * scale}`}
    height={`${47 * scale}`}
    viewBox='0 0 40 47'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 23.2422C0 35.9961 8.65723 46.4893 19.5264 46.4893C30.3955 46.4893 39.0479 35.9961 39.0479 23.2422C39.0479 10.4883 30.3955 1.19209e-06 19.5264 1.19209e-06C8.65723 1.19209e-06 0 10.4883 0 23.2422ZM1.74805 23.2422C1.74805 18.1543 3.20215 13.5059 5.62012 9.84375C10.1904 13.457 14.8389 15.3223 19.5264 15.3223C24.2139 15.3223 28.8623 13.457 33.4326 9.84375C35.8545 13.5059 37.3096 18.1543 37.3096 23.2422C37.3096 28.3301 35.8545 32.9785 33.4326 36.6406C28.8623 33.0273 24.2139 31.1621 19.5264 31.1621C14.8389 31.1621 10.1904 33.0273 5.62012 36.6406C3.20215 32.9785 1.74805 28.3301 1.74805 23.2422ZM6.64551 8.42773C9.36035 4.9707 13.0225 2.61719 17.0947 1.94336V5.36133H21.958V1.94336C26.0303 2.61719 29.6924 4.9707 32.4072 8.42773C28.042 11.9043 23.7646 13.584 19.5264 13.584C15.2881 13.584 11.0107 11.9043 6.64551 8.42773ZM6.64551 38.0566C11.0107 34.5801 15.2881 32.9004 19.5264 32.9004C23.7646 32.9004 28.042 34.5801 32.4072 38.0566C29.6924 41.5088 26.0303 43.8613 21.958 44.5391V41.1182H17.0947V44.5391C13.0225 43.8613 9.36035 41.5088 6.64551 38.0566ZM13.1689 29.5898H25.874L25.874 16.8848H13.1689V29.5898ZM14.917 27.832V18.6328H24.1162V27.832H14.917ZM17.1826 23.2422C17.1826 24.5215 18.2471 25.5859 19.5264 25.5859C20.8057 25.5859 21.8701 24.5215 21.8701 23.2422C21.8701 21.9629 20.8057 20.8984 19.5264 20.8984C18.2471 20.8984 17.1826 21.9629 17.1826 23.2422ZM18.833 44.7236V42.8662H20.2197V44.7236C19.9854 44.7344 19.7607 44.7412 19.5264 44.7412C19.292 44.7412 19.0674 44.7344 18.833 44.7236ZM18.833 3.62305V1.75781C19.0674 1.74805 19.292 1.73828 19.5264 1.73828C19.7607 1.73828 19.9854 1.74805 20.2197 1.75781V3.62305H18.833ZM18.9307 23.2422C18.9307 22.9004 19.1846 22.6465 19.5264 22.6465C19.8682 22.6465 20.1221 22.9004 20.1221 23.2422C20.1221 23.584 19.8682 23.8379 19.5264 23.8379C19.1846 23.8379 18.9307 23.584 18.9307 23.2422Z'
      fill={color}
    />
  </svg>
)

const RugbyPitchSvg = ({ color, scale, active }: any) => (
  <svg
    width={`${32 * scale}`}
    height={`${45 * scale}`}
    viewBox='0 0 32 45'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M26.8179 25.9844L26.8177 25.5274L25.6895 25.5277L25.6896 25.9847L26.8179 25.9844Z'
      fill={color}
    />
    <path
      d='M22.3383 25.9857L22.3381 25.5287L21.2546 25.529L21.2547 25.986L22.3383 25.9857Z'
      fill={color}
    />
    <path
      d='M20.1264 25.9863L20.1262 25.5294L18.998 25.5297L18.9981 25.9867L20.1264 25.9863Z'
      fill={color}
    />
    <path
      d='M17.9033 25.987L17.9032 25.53L16.7749 25.5304L16.7751 25.9873L17.9033 25.987Z'
      fill={color}
    />
    <path
      d='M15.6358 25.9877L15.6356 25.5308L14.5409 25.5311L14.541 25.9881L15.6358 25.9877Z'
      fill={color}
    />
    <path
      d='M13.4129 25.9884L13.4127 25.5314L12.2845 25.5317L12.2846 25.9887L13.4129 25.9884Z'
      fill={color}
    />
    <path
      d='M8.93324 25.9896L8.93311 25.5326L7.84953 25.5329L7.84967 25.9899L8.93324 25.9896Z'
      fill={color}
    />
    <path
      d='M11.2009 25.9889L11.2008 25.5319L10.0726 25.5322L10.0727 25.9892L11.2009 25.9889Z'
      fill={color}
    />
    <path
      d='M4.49855 25.9909L4.49841 25.5339L3.37016 25.5343L3.37029 25.9913L4.49855 25.9909Z'
      fill={color}
    />
    <path
      d='M17.4823 38.6428L17.4822 38.1858L16.0635 38.1862L16.0636 38.6432L17.4823 38.6428Z'
      fill={color}
    />
    <path
      d='M14.9689 38.6436L14.9688 38.1866L13.5501 38.1871L13.5502 38.644L14.9689 38.6436Z'
      fill={color}
    />
    <path
      d='M23.4774 25.5284L23.4776 25.9854L23.768 25.9853L23.7681 26.3677L24.349 26.3675L24.3489 25.9851L24.6058 25.9851L24.6057 25.5281L24.3488 25.5281L24.3487 25.1458L23.7678 25.1459L23.7679 25.5283L23.4774 25.5284Z'
      fill={color}
    />
    <path
      d='M17.4729 6.12209L17.4728 5.6651L16.0541 5.66551L16.0542 6.1225L17.4729 6.12209Z'
      fill={color}
    />
    <path
      d='M14.9594 6.12288L14.9592 5.66589L13.5405 5.66631L13.5407 6.12329L14.9594 6.12288Z'
      fill={color}
    />
    <path
      d='M5.58157 25.5336L5.5817 25.9905L6.72112 25.9902L6.72124 26.3726L7.25743 26.3724L7.25708 25.1507L6.72088 25.1509L6.72099 25.5332L5.58157 25.5336Z'
      fill={color}
    />
    <path
      d='M2.99369 37.7704L2.99329 36.3715L2.44592 36.3716L2.44633 37.7706L2.99369 37.7704Z'
      fill={color}
    />
    <path
      d='M2.98515 7.94496L2.98474 6.54602L2.43737 6.54618L2.43778 7.94512L2.98515 7.94496Z'
      fill={color}
    />
    <path
      d='M2.98576 9.80086L2.98535 8.40192L2.43798 8.40208L2.43839 9.80102L2.98576 9.80086Z'
      fill={color}
    />
    <path
      d='M2.98625 11.6475L2.98584 10.2486L2.43847 10.2488L2.43888 11.6477L2.98625 11.6475Z'
      fill={color}
    />
    <path
      d='M2.98722 15.3966L2.98682 13.9977L2.43945 13.9978L2.43986 15.3968L2.98722 15.3966Z'
      fill={color}
    />
    <path
      d='M2.98783 17.2433L2.98743 15.8444L2.44006 15.8445L2.44047 17.2435L2.98783 17.2433Z'
      fill={color}
    />
    <path
      d='M2.98832 19.1365L2.98792 17.7375L2.44055 17.7377L2.44095 19.1367L2.98832 19.1365Z'
      fill={color}
    />
    <path
      d='M2.98893 20.9831L2.98853 19.5841L2.44116 19.5843L2.44156 20.9832L2.98893 20.9831Z'
      fill={color}
    />
    <path
      d='M2.99125 28.4348L2.99084 27.0358L2.44348 27.036L2.44388 28.4349L2.99125 28.4348Z'
      fill={color}
    />
    <path
      d='M2.99064 26.5789L2.99023 25.1799L2.44287 25.1801L2.44327 26.579L2.99064 26.5789Z'
      fill={color}
    />
    <path
      d='M2.99003 24.7323L2.98962 23.3333L2.44226 23.3335L2.44266 24.7324L2.99003 24.7323Z'
      fill={color}
    />
    <path
      d='M2.99162 30.3187L2.99121 28.9198L2.44384 28.92L2.44425 30.3189L2.99162 30.3187Z'
      fill={color}
    />
    <path
      d='M2.99284 34.0305L2.99243 32.6316L2.44506 32.6318L2.44547 34.0307L2.99284 34.0305Z'
      fill={color}
    />
    <path
      d='M2.9932 35.9146L2.9928 34.5156L2.44543 34.5158L2.44584 35.9147L2.9932 35.9146Z'
      fill={color}
    />
    <path
      d='M28.6309 37.763L28.6305 36.364L28.0384 36.3642L28.0388 37.7631L28.6309 37.763Z'
      fill={color}
    />
    <path
      d='M28.6222 7.93752L28.6218 6.53857L28.0298 6.53875L28.0302 7.93769L28.6222 7.93752Z'
      fill={color}
    />
    <path
      d='M28.6227 9.79348L28.6223 8.39453L28.0303 8.3947L28.0307 9.79365L28.6227 9.79348Z'
      fill={color}
    />
    <path
      d='M28.6233 11.6401L28.6229 10.2411L28.0309 10.2413L28.0313 11.6403L28.6233 11.6401Z'
      fill={color}
    />
    <path
      d='M28.6243 15.3893L28.6239 13.9904L28.0318 13.9905L28.0323 15.3895L28.6243 15.3893Z'
      fill={color}
    />
    <path
      d='M28.625 17.2358L28.6246 15.8369L28.0326 15.837L28.033 17.236L28.625 17.2358Z'
      fill={color}
    />
    <path
      d='M28.6259 20.9757L28.6255 19.5767L28.0334 19.5769L28.0338 20.9758L28.6259 20.9757Z'
      fill={color}
    />
    <path
      d='M28.628 28.4274L28.6276 27.0284L28.0355 27.0286L28.0359 28.4276L28.628 28.4274Z'
      fill={color}
    />
    <path
      d='M27.9569 25.5271L27.9571 25.9841L28.0353 25.984L28.0354 26.5716L28.6275 26.5714L28.6273 25.9839L29.0406 25.9838L29.0405 25.5268L28.6272 25.5269L28.6271 25.1725L28.035 25.1727L28.0351 25.5271L27.9569 25.5271Z'
      fill={color}
    />
    <path
      d='M28.6272 24.7248L28.6268 23.3259L28.0348 23.326L28.0352 24.725L28.6272 24.7248Z'
      fill={color}
    />
    <path
      d='M28.6287 30.3112L28.6283 28.9123L28.0362 28.9125L28.0366 30.3114L28.6287 30.3112Z'
      fill={color}
    />
    <path
      d='M28.6297 34.0231L28.6293 32.6241L28.0372 32.6243L28.0376 34.0233L28.6297 34.0231Z'
      fill={color}
    />
    <path
      d='M28.6303 35.9071L28.6299 34.5081L28.0378 34.5083L28.0382 35.9072L28.6303 35.9071Z'
      fill={color}
    />
    <path
      d='M30.9991 0L30.4518 0.000159005L5.73545e-05 0.00900481L0.0129259 44.3089L31.012 44.2999L30.9991 0ZM17.059 3.62265L17.0588 3.14701L16.4668 3.14718L16.4669 3.62282L14.5344 3.62338L14.5342 3.14774L13.9869 3.1479L13.987 3.62354L1.12936 3.62728L1.12858 0.950633L29.8712 0.942283L29.8719 3.61893L17.059 3.62265ZM24.3448 12.0515L24.3447 11.5759L23.7526 11.576L23.7528 12.0517L7.24226 12.0565L7.24212 11.5808L6.69475 11.581L6.69489 12.0566L1.12064 12.0582L1.11847 4.57856L2.43663 4.57818L2.43695 5.67868L1.97895 5.67882L1.97908 6.1358L3.40894 6.13539L3.40881 5.6784L2.98432 5.67852L2.984 4.57802L6.71506 4.57694L6.71538 5.67744L6.25738 5.67757L6.25751 6.13456L7.68738 6.13415L7.68724 5.67716L7.26275 5.67728L7.26243 4.57678L14.0096 4.57482L14.0097 5.01315L14.5571 5.013L14.557 4.57466L16.4895 4.5741L16.4897 5.01243L17.0817 5.01226L17.0816 4.57393L23.7841 4.57198L23.7844 5.67248L23.3711 5.6726L23.3712 6.12959L24.7899 6.12918L24.7898 5.67219L24.3765 5.67231L24.3762 4.57181L28.0625 4.57074L28.0629 5.67124L27.6495 5.67136L27.6497 6.12835L29.0684 6.12793L29.0682 5.67095L28.6549 5.67107L28.6546 4.57056L29.9169 4.5702L29.9191 12.0499L24.3448 12.0515ZM28.6372 21.6843L28.6372 21.4418L28.0451 21.442L28.0452 21.6845L24.3588 21.6856L24.3587 21.2286L23.7666 21.2287L23.7667 21.6857L15.8019 21.688L15.8019 21.4456L15.2545 21.4457L15.2546 21.6882L7.25623 21.6905L7.2561 21.2335L6.70873 21.2337L6.70886 21.6907L2.9778 21.6918L2.97773 21.4493L2.43036 21.4494L2.43043 21.6919L1.13461 21.6923L1.13377 18.7918L2.22851 18.7915L2.22836 18.2972L1.13362 18.2975L1.13208 13.0002L2.43907 12.9998L2.43923 13.5407L2.9866 13.5406L2.98645 12.9997L6.7175 12.9986L6.71763 13.4369L7.26501 13.4368L7.26488 12.9984L23.7642 12.9936L23.7643 13.432L24.3564 13.4318L24.3563 12.9935L28.0426 12.9924L28.0428 13.5333L28.6349 13.5331L28.6347 12.9922L29.897 12.9918L29.8995 21.684L28.6372 21.6843ZM28.6512 31.3464L28.651 30.7681L28.059 30.7683L28.0591 31.3465L24.3728 31.3476L24.3726 30.844L23.7806 30.8441L23.7807 31.3478L7.27021 31.3526L7.27006 30.8489L6.72269 30.8491L6.72284 31.3527L2.99178 31.3538L2.99161 30.7756L2.44424 30.7757L2.44441 31.354L1.14859 31.3543L1.14703 25.9917L2.24177 25.9914L2.24164 25.5344L2.23047 25.5344L1.13572 25.5347L1.13488 22.6343L2.44187 22.6339L2.44193 22.8391L2.98931 22.8389L2.98925 22.6337L6.7203 22.6326L6.72044 23.0896L7.26781 23.0895L7.26768 22.6325L15.266 22.6302L15.2661 22.8353L15.8134 22.8352L15.8134 22.63L23.7782 22.6277L23.7783 23.0847L24.3704 23.0845L24.3702 22.6275L28.0566 22.6264L28.0567 22.8316L28.6487 22.8314L28.6487 22.6263L29.911 22.6259L29.9135 31.346L28.6512 31.3464ZM28.6313 39.7773L28.631 38.6395L29.0443 38.6394L29.0442 38.1824L27.6255 38.1828L27.6256 38.6398L28.0389 38.6397L28.0393 39.7775L24.3529 39.7786L24.3525 38.6408L24.7659 38.6406L24.7657 38.1837L23.347 38.1841L23.3472 38.6411L23.7605 38.6409L23.7608 39.7787L17.0583 39.7807L17.0582 39.2771L16.4661 39.2772L16.4663 39.7809L14.5337 39.7814L14.5336 39.2778L13.9862 39.278L13.9863 39.7816L7.23915 39.7835L7.23882 38.6457L7.66331 38.6456L7.66318 38.1886L6.23331 38.189L6.23344 38.646L6.69144 38.6459L6.69177 39.7837L2.96071 39.7848L2.96038 38.647L3.38488 38.6469L3.38474 38.1899L1.95487 38.1903L1.955 38.6473L2.44652 38.6471L2.44685 39.7849L1.15104 39.7853L1.14886 32.2683L6.7231 32.2667L6.72324 32.7423L7.27061 32.7422L7.27048 32.2665L23.7698 32.2617L23.77 32.7374L24.362 32.7372L24.3619 32.2616L29.8914 32.26L29.8936 39.777L28.6313 39.7773ZM1.15208 43.3666L1.1513 40.69L14.0089 40.6862L14.0091 41.1619L14.5565 41.1617L14.5563 40.6861L16.4889 40.6855L16.489 41.1611L17.0811 41.161L17.0809 40.6853L29.8827 40.6816L29.8835 43.3583L1.15208 43.3666Z'
      fill={color}
    />
    <path
      d='M27.9548 18.2899L27.9549 18.7748L28.0331 18.7748L28.0332 19.1292L28.6253 19.129L28.6252 18.7746L29.0385 18.7745L29.0384 18.2896L28.6251 18.2897L28.6249 17.7301L28.0328 17.7303L28.033 18.2899L27.9548 18.2899Z'
      fill={color}
    />
    <path
      d='M26.8156 18.7751L26.8154 18.2902L25.6872 18.2905L25.6873 18.7755L26.8156 18.7751Z'
      fill={color}
    />
    <path
      d='M24.3467 18.2909L24.3466 17.9365L23.7657 17.9367L23.7658 18.2911L23.4754 18.2912L23.4755 18.7762L23.7659 18.7761L23.766 19.1305L24.3469 19.1303L24.3468 18.7759L24.6038 18.7758L24.6036 18.2909L24.3467 18.2909Z'
      fill={color}
    />
    <path
      d='M22.3363 18.7764L22.3362 18.2914L21.2526 18.2918L21.2527 18.7767L22.3363 18.7764Z'
      fill={color}
    />
    <path
      d='M20.1244 18.7771L20.1243 18.2921L18.996 18.2924L18.9962 18.7774L20.1244 18.7771Z'
      fill={color}
    />
    <path
      d='M17.9013 18.7778L17.9011 18.2928L16.7729 18.2931L16.773 18.7781L17.9013 18.7778Z'
      fill={color}
    />
    <path
      d='M15.6337 18.7784L15.6335 18.2935L14.5388 18.2938L14.5389 18.7787L15.6337 18.7784Z'
      fill={color}
    />
    <path
      d='M13.4108 18.779L13.4106 18.294L12.2824 18.2943L12.2825 18.7793L13.4108 18.779Z'
      fill={color}
    />
    <path
      d='M8.93129 18.7803L8.93115 18.2953L7.84758 18.2957L7.84772 18.7806L8.93129 18.7803Z'
      fill={color}
    />
    <path
      d='M11.1989 18.7796L11.1987 18.2947L10.0705 18.295L10.0706 18.78L11.1989 18.7796Z'
      fill={color}
    />
    <path
      d='M6.71893 17.9416L6.71903 18.296L5.5796 18.2964L5.57974 18.7813L6.71917 18.781L6.71927 19.1354L7.25547 19.1352L7.25513 17.9415L6.71893 17.9416Z'
      fill={color}
    />
    <path
      d='M4.49636 18.7816L4.49622 18.2966L3.36796 18.297L3.3681 18.7819L4.49636 18.7816Z'
      fill={color}
    />
  </svg>
)

export const Pitch = ({
  color = sportableColors.colors.sportableGreyDark,
  scale,
  active = true,
  sport,
  sportType
}: PitchProps) => {
  const sportToRender = sport || getSport(sportType)

  const svgComponents = {
    soccer: SoccerPitchSvg,
    americanFootball: AmericanOrCanadianFootballPitchSvg,
    canadianFootball: AmericanOrCanadianFootballPitchSvg,
    australianRules: AFLPitchSvg,
    rugbyUnion: RugbyPitchSvg,
    rugbyLeague: RugbyPitchSvg
  }

  const SvgComponent = svgComponents[sportToRender.key]

  return SvgComponent ? (
    <SvgComponent color={color} scale={scale} active={active} />
  ) : (
    <svg
      width={`${32 * scale}`}
      height={`${45 * scale}`}
      viewBox='0 0 32 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M31 44L31 1L1 1L1 44H31Z' stroke={color} strokeWidth='2' />
      <path
        d='M31 6.5L1 6.5'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='square'
      />
      <path
        d='M31 38.5H1'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='square'
      />
      <path
        d='M31 22.5L1 22.5'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='square'
      />
      <path
        d='M31 30.5H17.6509L1 30.5'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='square'
        stroke-dasharray='3 6'
      />
      <path
        d='M31 13.5L1 13.5'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='square'
        stroke-dasharray='3 6'
      />
    </svg>
  )
}
